import { render, staticRenderFns } from "./WorkFileChip.vue?vue&type=template&id=04e47ebe&scoped=true"
import script from "./WorkFileChip.vue?vue&type=script&lang=js"
export * from "./WorkFileChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e47ebe",
  null
  
)

export default component.exports